import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '../../components/ui';
import { useT } from '../../i18n';
import './RegistrationSuccessPage.css';

const messages = {
  title: { tr: 'Hesabınız Hazır!', en: 'Your Account Is Ready!' },
  subtitle: {
    tr: ({ org }) => <><strong>{org}</strong> için kaydınız tamamlandı. Hemen panele giriş yapıp Outlook eklentinizi kurabilirsiniz.</>,
    en: ({ org }) => <>Registration for <strong>{org}</strong> is complete. Sign in to the panel and set up your Outlook add-in right away.</>,
  },
  goToPanel: { tr: 'Panele Git', en: 'Go to Panel' },
  needHelp: { tr: 'Yardıma mı ihtiyacınız var?', en: 'Need help?' },
  helpText: { tr: 'Herhangi bir sorunuz varsa bizimle iletişime geçmekten çekinmeyin:', en: 'If you have any questions, don’t hesitate to get in touch:' },
};

export const RegistrationSuccessPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationName } = location.state || {};
  const { t } = useT(messages);

  useEffect(() => {
    if (!organizationName) {
      navigate('/register');
    }
  }, [organizationName, navigate]);

  if (!organizationName) return null;

  return (
    <div className="success-page">
      <div className="success-container">
        <div className="success-icon-wrapper">
          <svg className="success-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="success-title">{t('title')}</h1>

        <p className="success-subtitle">{t('subtitle', { org: organizationName })}</p>

        <Button onClick={() => navigate('/dashboard')} className="success-cta-btn">
          {t('goToPanel')}
        </Button>

        <div className="support-box">
          <h3>{t('needHelp')}</h3>
          <p>{t('helpText')}</p>
          <a href="mailto:destek@martinci.com" className="contact-link">
            <svg fill="currentColor" viewBox="0 0 20 20">
              <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
              <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
            </svg>
            destek@martinci.com
          </a>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccessPage;
